import { h, Component } from 'preact';
import style from './style.css';
import Header from '../Header'
import cx from 'classnames';
import { goToTop } from 'react-scrollable-anchor'

class PrivacyPolicy extends Component {
    render(props) {
        goToTop()
    return <div className={cx(style.list, 'flex', 'flex-col')}>
        <Header leadingSlash='/' />
        <div>
            <ol>
            <h1>Privacy Policy</h1>
            This privacy policy sets out the data processing practices carried out through the use of the Internet and any other electronic communications networks by Playerindex. If you have any requests concerning your personal information or any queries with regard to these practices please contact us at privacy@playerindex.com.
 <br />
 <br />
 <h3>Information Collected</h3>
 <br />  
 Every time you visit our website, move from page to page, read pages, or download content onto your computer, we learn which pages are visited and what content is downloaded. However, this is measured only in aggregate and not on an individual basis.
 <br />  
 When you send us an e-mail or ask us to respond to you by e-mail, we learn your e-mail address and the information that you have included in the email form shown on our website.
 <br />
 <br />  
 <h3>Use of Personal Information</h3>
 <br />  
 We use the aggregate statistical information to determine how many people visit our website and which sections of the site are visited most frequently. This helps us to know what type of information is most popular so that we can improve our website and make it easier for you to access this information. We record the statistical information on the number of visitors to our website but no information about you in particular is kept or used.
 <br />  
 In relation to the information we gain when you email us, we may use your e-mail address to acknowledge your comments and/or reply to your questions and we may store your communication and our reply in case we need to correspond at a later date. We will not provide your e-mail address to anyone.
 <br />  
 <br />
 <h3>Disclosures</h3>
 <br />
 We will only disclose personal information to other companies within our group of companies, government bodies and law enforcement agencies, successors in title to our business and suppliers we engage to process data on our behalf.
 <br />  
 <br />
 <h3>Internet-based Transfers</h3>
 <br />
 Given that the Internet is a global environment, using the Internet to collect and process personal data necessarily involves the transmission of data on an international basis. Therefore by browsing this website and communicating electronically with us, you acknowledge and agree to our processing of personal data this way.
 
</ol>
        </div>
    </div>;
    }
}

export default PrivacyPolicy;


// WEBPACK FOOTER //
// ./components/PrivacyPolicy/index.jsx